import state from '../state';
import { setMoment, onReady } from '../i18nService';

const initI18n = async (options, { moment } = {}) => {
  Object.assign(state, {
    ...state,
    ...options,
  });

  const { fileHash, fetchUrl, lang, fileExtension } = state;

  const langResponse = await fetch(`${fetchUrl}/${lang}${fileExtension}?v=${fileHash}`);
  state.translations[lang] = await langResponse.json();
  if (moment) {
    setMoment(moment);
  }
  onReady();
};

export default initI18n;
